import '../../sass/pages/_landing.scss'

// IMPORT SERVICES
import { sendDataLayer } from "../services/datalayers";
import { trenzasService } from "../services/api";
import { loadUrlFile, setAndGetCookie } from "../utils/helpers";
const api = new trenzasService();

// IMPORT COMPONENTS
import Counter from "../components/counter";
import Modal from "../components/modal";
import "../components/passionPoints";
import "../components/clock";
import "../components/elementDatalayers";
import { dataLayerTapit } from "../components/elementDatalayers";

// IMPORT LIBRARIES
import Swiper, { Navigation, EffectCreative, Lazy, Autoplay } from "swiper";
import "swiper/css";

declare var gsap: any;
declare var ScrollTrigger: any;
gsap.registerPlugin(ScrollTrigger);
declare global {
    interface Window {
        initSession: any
        dataLayer: any
    }
}

let cardImage: HTMLElement;
let userCounter: Counter;

// Initialize
init()

window.addEventListener('load', () => {
    const tl = gsap.timeline()
    userCounter?.showCounter()

    // Banner
    tl.to('.trnz-banner__image, .trnz-banner__title, .trnz-banner__desc, .trnz-banner__video, .trnz-banner__btn', {
        duration: 0.8, opacity: 1, translateY: 0, stagger: .2
    })

    // Map
    let mapElms = gsap.utils.toArray('.trnz-map__title, .trnz-group-button__item')
    mapElms.forEach((elm: any) => {
        gsap.to(elm, {
            duration: 0.8, opacity: 1, translateY: 0, scrollTrigger: { trigger: elm, start: 'top bottom-=30px' }
        })
    })

    // Learn More
    let learnElms = gsap.utils.toArray('.trnz-learn-more__title, .trnz-learn-more__desc, .trnz-learn-more__btn')
    learnElms.forEach((elm: any) => {
        gsap.to(elm, {
            duration: 0.8, opacity: 1, translateY: 0, scrollTrigger: { trigger: elm, start: 'top bottom-=50px' }
        })
    })

    // Chapter
    let chapterFeatured = gsap.utils.toArray('.trnz-chapter__title, .trnz-card-chapter__desc, .trnz-chapter-featured__title, .trnz-chapter-featured__desc, .trnz-chapter-featured__wrapper-video')
    chapterFeatured.forEach((elm: any) => {
        gsap.to(elm, {
            duration: .8, opacity: 1, translateX: 0, translateY: 0, scrollTrigger: { trigger: elm, start: 'top bottom-=50px' }
        })
    })

    // Culture
    let cultureElms = gsap.utils.toArray('.trnz-culture__title, .trnz-culture__desc, .trnz-culture__image, .trnz-culture__btn')
    cultureElms.forEach((elm: any) => {
        gsap.to(elm, {
            duration: .8, opacity: 1, translateY: 0, scrollTrigger: { trigger: elm, start: 'top bottom-=50px' }
        })
    })

    // Podcast
    gsap.to('.trnz-podcast-card', {
        opacity: 1, translateY: 0, scrollTrigger: { trigger: '.trnz-podcast-card', start: 'top bottom-=50px' }
    })
    let podcastTexts = gsap.utils.toArray('.trnz-podcast-card__title, .trnz-podcast-card__info, .trnz-podcast-card__desc')
    podcastTexts.forEach((elm: any) => {
        gsap.to(elm, {
            duration: .8, opacity: 1, translateX: 0, scrollTrigger: { trigger: elm, start: 'top bottom-=50px' }
        })
    })
    let podcastElms = gsap.utils.toArray('.trnz-podcast__btn, .trnz-podcast-card__image, .trnz-podcast-card__iframe')
    podcastElms.forEach((elm: any) => {
        gsap.to(elm, {
            duration: .8, opacity: 1, translateY: 0, scrollTrigger: { trigger: elm, start: 'top bottom-=50px' }
        })
    })

    // Tada
    gsap.to('.trnz-tada__logo', {
        duration: .8, opacity: 1, scrollTrigger: { trigger: '.trnz-tada__logo', start: 'top bottom-=50px' }
    })
    let tadaElms = gsap.utils.toArray('.trnz-tada__title, .trnz-tada__desc')
    tadaElms.forEach((elm: any) => {
        gsap.to(elm, {
            duration: .8, opacity: 1, translateY: 0, scrollTrigger: { trigger: elm, start: 'top bottom-=50px' }
        })
    })

    // Wallpaper
    let backgroundTexts = gsap.utils.toArray('.trnz-wallpaper__stroke-title, .trnz-wallpaper__title, .trnz-wallpaper__pride')
    backgroundTexts.forEach((elm: any) => {
        gsap.to(elm, {
            duration: .8, opacity: 1, ease: 'power3.in', scrollTrigger: { trigger: elm, start: 'top bottom-=50px' }
        })
    })

    // Social
    let socialDesc = gsap.utils.toArray('.trnz-social__title, .trnz-social__desc')
    socialDesc.forEach((elm: any) => {
        gsap.to(elm, {
            duration: .8, opacity: 1, translateY: 0, scrollTrigger: { trigger: elm, start: 'top bottom-=30px' }
        })
    })
    gsap.to('.trnz-social__link', {
        duration: .8, opacity: 1, translateY: 0, stagger: .2, scrollTrigger: { trigger: '.trnz-social__nav', start: 'top bottom-=50px' }
    })

    // Buttons
    let buttons = gsap.utils.toArray('.trnz-tada__btn, .trnz-wallpaper__btn, .trnz-social__btn')
    buttons.forEach((elm: any) => {
        gsap.to(elm, {
            duration: .8, opacity: 1, translateY: 0, scrollTrigger: { trigger: elm, start: 'top bottom-=50px' }
        })
    })

    // Card Swiper
    gsap.to('.trnz-instruction-image', {
        duration: .8, opacity: 1, translateX: 0, stagger: .2, scrollTrigger: { trigger: '#instructionSwiper', start: 'top bottom-=50px' }
    })
    gsap.to('.trnz-card-chapter', {
        duration: .8, opacity: 1, translateX: 0, stagger: .2, scrollTrigger: { trigger: '#chapterSwiper', start: 'top bottom-=50px' }
    })
    gsap.to('.trnz-card-tada', {
        duration: .8, opacity: 1, translateY: 0, stagger: .2, scrollTrigger: { trigger: '#tadaSwiper', start: 'top bottom-=50px' }
    })
    gsap.to('.trnz-wallpaper-card', {
        duration: .8, opacity: 1, translateY: 0, scrollTrigger: { trigger: '#wallpaperSwiper', start: 'top bottom-=50px' }
    })
    gsap.to('.feed-item', {
        duration: .8, opacity: 1, translateX: 0, stagger: .2, scrollTrigger: { trigger: '.juicer-feed', start: 'top bottom-=50px' }
    })
})

function init() {
    setInitialState()

    new Modal('#ModalVideoHigh', {
        activators: '.trnz-banner .trnz-video-preview', iframeWrapper: 'iframeHigh',
        onClose(e, modal) {
            sendDataLayer({
                'event': 'GAEvent',
                'event_category': 'Video',
                'event_action': 'Close Video High',
                'event_label': modal.playerModal?.videoTitle || '',
                'interaction': 'true'
            })
        },
        playerEvents: {
            onStateChange(player: any) {
                switch (player.data) {
                    case 0:
                        sendDataLayer({
                            'event': 'GAEvent',
                            'event_category': 'Video',
                            'event_action': 'Completed Video High',
                            'event_label': player.target.videoTitle || '',
                            'interaction': 'true'
                        })
                        break;
                    case 1:
                        sendDataLayer({
                            'event': 'GAEvent',
                            'event_category': 'Video',
                            'event_action': 'Play Video High',
                            'event_label': player.target.videoTitle || '',
                            'interaction': 'true'
                        })
                        break;
                }
            },
        }
    })

    new Modal('#ModalVideoMedium', {
        activators: '.trnz-chapter-featured .trnz-video-preview', iframeWrapper: 'iframeMedium',
        onClose(e, modal) {
            sendDataLayer({
                'event': 'GAEvent',
                'event_category': 'Video',
                'event_action': 'Close Video Medium',
                'event_label': modal.playerModal?.videoTitle || '',
                'interaction': 'true'
            })
        },
        playerEvents: {
            onStateChange(player: any) {
                switch (player.data) {
                    case 0:
                        sendDataLayer({
                            'event': 'GAEvent',
                            'event_category': 'Video',
                            'event_action': 'Completed Video Medium',
                            'event_label': player.target.videoTitle || '',
                            'interaction': 'true'
                        })
                        break;
                    case 1:
                        sendDataLayer({
                            'event': 'GAEvent',
                            'event_category': 'Video',
                            'event_action': 'Play Video Medium',
                            'event_label': player.target.videoTitle || '',
                            'interaction': 'true'
                        })
                        break;
                }
            },
        }
    })

    new Modal('#ModalVideoFold', {
        activators: '#chapterSwiper .trnz-card-chapter__image', iframeWrapper: 'iframeFold',
        playerEvents: {
            onStateChange(player: any) {
                switch (player.data) {
                    case 0:
                        sendDataLayer({
                            'event': 'GAEvent',
                            'event_category': 'Video',
                            'event_action': 'Completed Fold Videos',
                            'event_label': player.target.videoTitle || '',
                            'interaction': 'true'
                        })
                        break;
                    case 1:
                        sendDataLayer({
                            'event': 'GAEvent',
                            'event_category': 'Video',
                            'event_action': 'Play Fold Videos',
                            'event_label': player.target.videoTitle || '',
                            'interaction': 'true'
                        })
                        break;
                }
            },
        }
    })
    let downloadModal = new Modal('#popupDownload', { mainClass: 'trnz-popup' })
    let questionModal = new Modal('#popupQuestions', { mainClass: 'trnz-popup' })

    handlerDownloadBtn({ downloadModal, questionModal })

    let urlParams = new URLSearchParams(location.search)

    setTimeout(() => {
        dataLayerTapit();
        downloadModal.refModal.target.classList.remove(`${downloadModal.options.mainClass}--hide`)
    }, 5000);

    api.getCounter()
        .then((response) => response.json())
        .then((visits) => {
            userCounter = new Counter('.trnz-counter', visits || 0)
        })
        .catch((error) => {
            userCounter = new Counter('.trnz-counter', 0)
            console.error('error:', error)
        });

    createSwiper()
}

function setInitialState() {
    // Banner
    gsap.set('.trnz-banner__image, .trnz-banner__title, .trnz-banner__desc, .trnz-banner__video, .trnz-banner__btn', { opacity: 0, translateY: 30 })

    // Map
    gsap.set('.trnz-map__title, .trnz-group-button__item', { opacity: 0, translateY: 30 })

    // Learn More
    gsap.set('.trnz-learn-more__title, .trnz-learn-more__desc, .trnz-learn-more__btn', { opacity: 0, translateY: 30 })

    // Chapter
    gsap.set('.trnz-chapter-featured__title, .trnz-chapter-featured__desc, .trnz-chapter-featured__wrapper-video', { opacity: 0, translateX: -30 })
    gsap.set('.trnz-chapter__title, .trnz-card-chapter__desc', { opacity: 0, translateY: 30 })

    // Culture
    gsap.set('.trnz-culture__title, .trnz-culture__desc, .trnz-culture__image, .trnz-culture__btn', { opacity: 0, translateY: 30 })

    // Podcast
    gsap.set('.trnz-podcast-card', { opacity: 0, translateY: 30 })
    gsap.set('.trnz-podcast-card__title, .trnz-podcast-card__info, .trnz-podcast-card__desc', { opacity: 0, translateX: -30 })
    gsap.set('.trnz-podcast__btn, .trnz-podcast-card__image, .trnz-podcast-card__iframe', { opacity: 0, translateY: 30 })

    // Tada
    gsap.set('.trnz-tada__logo', { opacity: 0 })
    gsap.set('.trnz-tada__title, .trnz-tada__desc', { opacity: 0, translateY: 30 })

    // Wallpaper
    gsap.set('.trnz-wallpaper__stroke-title, .trnz-wallpaper__title, .trnz-wallpaper__pride', { opacity: 0 })

    // Social
    gsap.set('.trnz-social__title, .trnz-social__desc, .trnz-social__link', { opacity: 0, translateY: 30 })

    // Buttons
    gsap.set('.trnz-tada__btn, .trnz-wallpaper__btn, .trnz-social__btn', { opacity: 0, translateY: 30 })

    // Card Swiper
    gsap.set('.trnz-instruction-image, .trnz-card-chapter, .feed-item', { opacity: 0, translateX: 30 })
    gsap.set('.trnz-card-tada, .trnz-wallpaper-card', { opacity: 0, translateY: 30 })
}

// ESTABLECE LA FUNCIONALIDAD PARA LOS BOTONES DE DESCARGAR
function handlerDownloadBtn({ downloadModal, questionModal }: any) {
    let pdfButtons = document.querySelectorAll('.trnz-culture__btn,.trnz-banner__btn,.trnz-learn-more__btn')
    for (let index = 0; index < pdfButtons.length; index++) {
        pdfButtons[index]?.addEventListener('click', (e) => {
            e.preventDefault()
            let pfdFile = document.querySelector('.trnz-culture__btn') as HTMLButtonElement;
            let downloadFile = setAndGetCookie('downloadFile', pfdFile.dataset.downloadFile)

            downloadModal.refModal.target.classList.remove(`${downloadModal.options.mainClass}--hide`)
            loadUrlFile(downloadFile)
        })
    }

    document.querySelector('.trnz-wallpaper__btn')?.addEventListener('click', () => {
        let downloadFile = setAndGetCookie('downloadFile', cardImage.dataset.downloadImage)
        let downloadFileTitle = setAndGetCookie('downloadFileTitle', cardImage.dataset.titleImage)

        downloadModal.refModal.target.classList.remove(`${downloadModal.options.mainClass}--hide`)
        loadUrlFile(downloadFile, downloadFileTitle)
    })
}

// CONSULTA ENDPOINT
async function checkUser(callback: (data: any) => void) {
    try {
        let response = await api.validateAuth()
        let jsonData = await response.json()
        callback(jsonData);
    } catch (error) {
        console.error('e:', error);
    }
}

// CREA SWIPERS
function createSwiper() {
    new Swiper('#instructionSwiper', {
        spaceBetween: 20,
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        grabCursor: true,
        breakpoints: {
            768: {
                spaceBetween: 50,
                slidesPerView: 'auto',
                centerInsufficientSlides: true,
            },
            991: {
                spaceBetween: 70,
                slidesPerView: 'auto',
                centerInsufficientSlides: true,
            }
        }
    })

    new Swiper('#chapterSwiper', {
        modules: [Navigation],
        spaceBetween: 30,
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        grabCursor: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                spaceBetween: 40,
                slidesPerView: 'auto',
                centerInsufficientSlides: true,
            },
            991: {
                spaceBetween: 40,
                slidesPerView: 2,
                centerInsufficientSlides: true,
            },
            1367: {
                spaceBetween: 40,
                slidesPerView: 3,
                centerInsufficientSlides: true,
            }
        }
    })

    new Swiper('#tadaSwiper', {
        modules: [Navigation],
        spaceBetween: 40,
        slidesPerView: 1,
        centerInsufficientSlides: true,
        grabCursor: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            640: {
                spaceBetween: 40,
                slidesPerView: 2,
                centerInsufficientSlides: true,
            },
            1367: {
                spaceBetween: 40,
                slidesPerView: 3,
                centerInsufficientSlides: true,
            }
        }
    })

    new Swiper('#wallpaperSwiper', {
        modules: [Navigation, EffectCreative, Lazy, Autoplay],
        slidesPerView: "auto",
        centeredSlides: true,
        centerInsufficientSlides: true,
        grabCursor: true,
        effect: 'creative',
        loop: true,
        speed: 1000,
        lazy: true,
        preloadImages: false,
        autoplay: {
            delay: 10000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        creativeEffect: {
            limitProgress: 2,
            progressMultiplier: 2,
            prev: {
                translate: ["-25%", 0, -200],
                opacity: 0.76
            },
            next: {
                translate: ["25%", 0, -200],
                opacity: 0.76
            }
        },
        breakpoints: {
            991: {
                creativeEffect: {
                    progressMultiplier: 1,
                    prev: {
                        translate: ["-140%", 0, -200],
                        opacity: 1
                    },
                    next: {
                        translate: ["140%", 0, -200],
                        opacity: 1
                    }
                }
            }
        },
        on: {
            activeIndexChange(swiper) {
                let image = swiper.slides[swiper.activeIndex].querySelector('.trnz-wallpaper-card__image') as HTMLImageElement
                cardImage = swiper.slides[swiper.activeIndex].querySelector('.trnz-wallpaper-card') as HTMLImageElement
                changeBgImage(image?.src)
            },
            lazyImageReady(swiper, slideEl, imageEl: HTMLImageElement) {
                if (slideEl.classList.contains('swiper-slide-active')) changeBgImage(imageEl?.src)
            }
        }
    })

    function changeBgImage(nwImage: string | undefined) {
        if (nwImage === '') return
        let bgNewImage = document.querySelector('.trnz-wallpaper__bg:not(.trnz-wallpaper__bg--active)') as HTMLImageElement;
        let bgOldImage = document.querySelector('.trnz-wallpaper__bg--active') as HTMLImageElement;
        if (bgNewImage?.src) {
            bgNewImage.src = nwImage;
            bgNewImage.classList.add('trnz-wallpaper__bg--active')
            bgOldImage?.classList.remove('trnz-wallpaper__bg--active')
        }
    }
}

document.addEventListener('lazybeforeunveil', function (e: any) {
    var bgClass = e.target.getAttribute('data-bg-class');
    if (bgClass) e.target.classList.add(bgClass)
});
